import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 拒收管理列表
interface ReturnManagementData {
    token: string;
    limit: number;
    commodity_id: number;
    game_id: number;
    server_id: number;
    seller_username: number;
    purchaser_username: number;
    min_price: number;
    max_price: number;
}

export const returnManagement = (json: ReturnManagementData): any =>
    http.httpPost({
        url: httpApi.ReturnsManage.returnManagement,
        json,
    });
// 导出
interface ExportCsvData {
    token: string;
}

export const exportCsv = (json: ExportCsvData): any =>
    http.httpPost({
        url: httpApi.ReturnsManage.exportCsv,
        json,
    });
// 查看图片
interface ImageContrastData {
    token: string;
    commodity_id: number;
    order_id: number;
}

export const imageContrast = (json: ImageContrastData): any =>
    http.httpPost({
        url: httpApi.ReturnsManage.imageContrast,
        json,
    });
